<ng-container *ngIf="permissions$ | async as permissions">
  <div *ngIf="availableFilters.length > 0" class="row g-0">
    <div class="col">
      <div class="d-flex flex-wrap align-items-center gap-2">
        <div class="filters m-0 p-0 w-auto" ngbDropdown>
          <button id="add-filter" class="btn btn-outline-primary btn-xs btn-no-block" ngbDropdownToggle type="button">
            {{ "Filter results" | translate }}
          </button>
          <div [attr.aria-labelledby]="'add-filter'" class="fullscreen-on-mobile" ngbDropdownMenu>
            <button *ngIf="!permissions.mayAccess" (click)="showSubscriptionRequiredModal()" ngbDropdownItem>
              <fa-icon icon="lock"></fa-icon>
              <span
                [innerHTML]="
                  'To use this feature, you need the <strong>{{0}}</strong> subscription or higher.'
                    | translate: { '0': SimplifiedSubscriptionName.ASTROBIN_ULTIMATE_2020 }
                "
              >
              </span>
            </button>
            <button
              *ngFor="let filter of availableFilters"
              [disabled]="isActive(filter) || !permissions.mayAccess"
              (click)="addFilter(filter)"
              ngbDropdownItem
            >
              <fa-icon [icon]="permissions.mayAccess ? filter.icon : 'lock'"></fa-icon>
              {{ filter.label }}
            </button>
          </div>
        </div>

        <div *ngFor="let filter of activeFilters" class="filter">
          <div class="widget">
            <ng-container *ngIf="filter.widget === FilterWidget.SELECT">
              <div class="p-0 w-auto" ngbDropdown>
                <button
                  [id]="'filter-dropdown-' + filter.type"
                  class="btn btn-outline-secondbary btn-xs btn-no-block"
                  ngbDropdownToggle
                  type="button"
                >
                  <fa-icon [icon]="filter.icon"></fa-icon>
                  {{ filter.label }} =
                  {{ filter.value ? filter.humanizeValueFunction(filter.value) : ("Any" | translate) }}

                  <div [attr.aria-labelledby]="'filter-dropdown-' + filter.type" ngbDropdownMenu>
                    <div class="widget-content">
                      <label class="mb-2"> {{ "Select" | translate }}: </label>
                      <ng-select
                        [attr.id]="'filter-select-' + filter.type"
                        [clearable]="false"
                        [items]="filter.items"
                        (change)="setFilterValue(filter, $event.value)"
                        [(ngModel)]="filter.value"
                        bindLabel="label"
                        bindValue="value"
                      ></ng-select>
                    </div>
                  </div>
                </button>
                <button
                  (click)="removeFilter(filter)"
                  class="btn btn-outline-secondary btn-xs btn-close btn-no-block"
                  type="button"
                >
                  &times;
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="filter.widget === FilterWidget.TOGGLE">
              <div class="p-0 w-auto" ngbDropdown>
                <button
                  [id]="'filter-dropdown-' + filter.type"
                  class="btn btn-outline-secondary btn-xs btn-no-block"
                  ngbDropdownToggle
                  type="button"
                >
                  <fa-icon [icon]="filter.icon"></fa-icon> {{ filter.label }} = {{ filter.value | yesNo }}

                  <div [attr.aria-labelledby]="'filter-dropdown-' + filter.type" ngbDropdownMenu>
                    <div class="widget-content">
                      <astrobin-toggle-button
                        [label]="filter.label"
                        [value]="filter.value"
                        (toggle)="setFilterValue(filter, $event)"
                      ></astrobin-toggle-button>
                    </div>
                  </div>
                </button>
                <button
                  (click)="removeFilter(filter)"
                  class="btn btn-outline-secondary btn-xs btn-close btn-no-block"
                  type="button"
                >
                  &times;
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="filter.widget === FilterWidget.NUMBER_RANGE">
              <div class="p-0 w-auto" ngbDropdown>
                <button
                  [id]="'filter-dropdown-' + filter.type"
                  class="btn btn-outline-secondary btn-xs btn-no-block"
                  ngbDropdownToggle
                  type="button"
                >
                  <fa-icon [icon]="filter.icon"></fa-icon>
                  {{ filter.label }} = {{ filter.value.from || 0 }} - {{ filter.value.to || 0 }}

                  <div [attr.aria-labelledby]="'filter-dropdown-' + filter.type" ngbDropdownMenu>
                    <div class="widget-content">
                      <div class="mb-3">
                        <label [for]="'filter-dropdown-' + filter.type + '-from'" class="form-label">
                          {{ "From" | translate }}:
                        </label>
                        <input
                          [id]="'filter-dropdown-' + filter.type + '-from'"
                          (change)="setFilterValue(filter, { from: filter.value.from, to: filter.value.to })"
                          class="form-control"
                          [(ngModel)]="filter.value.from"
                          type="number"
                        />
                      </div>
                      <div>
                        <label [for]="'filter-dropdown-' + filter.type + '-to'" class="form-label">
                          {{ "To" | translate }}:
                        </label>
                        <input
                          [id]="'filter-dropdown-' + filter.type + '-to'"
                          (change)="setFilterValue(filter, { from: filter.value.from, to: filter.value.to })"
                          class="form-control"
                          [(ngModel)]="filter.value.to"
                          type="number"
                        />
                      </div>
                    </div>
                  </div>
                </button>
                <button
                  (click)="removeFilter(filter)"
                  class="btn btn-outline-secondary btn-xs btn-close btn-no-block"
                  type="button"
                >
                  &times;
                </button>
              </div>
            </ng-container>
          </div>
        </div>

        <button *ngIf="changed" (click)="apply()" class="btn btn-primary btn-xs btn-no-block" type="button">
          {{ "Apply" | translate }}
        </button>

        <a
          *ngIf="activeFilters.length > 0"
          (click)="clearFilters()"
          class="clear-filters"
          astrobinEventPreventDefault
          href="#"
        >
          <span class="d-block btn btn-xs btn-outline-secondary btn-no-block">
            {{ "Clear all filters" | translate }}
          </span>
        </a>
      </div>
      <!-- flex -->
    </div>
    <!-- col -->
  </div>
  <!-- row -->
</ng-container>
